/**
 * Amazon Polly (Neural / 話者 Takumi) で利用できない SSML タグの一覧。
 *
 * SSML チューニング画面 (Step3) の候補表示と音声合成の前に、
 * `components/ssmlTuning/ssmlDraft.ts` の `stripUnsupportedTags()` がこの一覧を使って
 * 利用不可タグを取り除く (サーバの除去をすり抜けた場合の最後の砦)。
 *
 * ⚠️ このファイルは **手で編集しないこと**。
 *   利用不可タグの唯一の正源は `lambda/common/ssml_unsupported_tags.py` で、本ファイルは
 *   `python3 scripts/gen_ssml_unsupported_tags_ts.py --write` で機械生成する。
 *   乖離は `tests/ssml_unsupported_tags_sync/` が CI で検知する。
 */

/**
 * タグの除去方法。
 *
 * - `unwrap`  … タグだけ外し、囲んでいた本文は残す
 * - `reading` … `<rt>むさしこすぎ</rt>` → `（むさしこすぎ）` のように括弧書きへ戻す
 * - `drop`    … タグと中身をまとめて捨てる (`<rp>（</rp>` のような表示用の括弧)
 */
export type SsmlTagRemovalMode = 'unwrap' | 'reading' | 'drop';

/** 利用不可タグ 1 件。 */
export interface UnsupportedSsmlTag {
  /** タグ名 (小文字 / 名前空間付きは `amazon:effect` のように書く)。 */
  readonly name: string;
  /** 除去方法。 */
  readonly removal: SsmlTagRemovalMode;
}

/** 利用不可タグの一覧 (正源の定義順)。 */
export const UNSUPPORTED_SSML_TAGS: readonly UnsupportedSsmlTag[] = [
  { name: 'emphasis', removal: 'unwrap' },
  { name: 'amazon:effect', removal: 'unwrap' },
  { name: 'amazon:auto-breaths', removal: 'unwrap' },
  { name: 'ruby', removal: 'unwrap' },
  { name: 'rb', removal: 'unwrap' },
  { name: 'rtc', removal: 'unwrap' },
  { name: 'rt', removal: 'reading' },
  { name: 'rp', removal: 'drop' },
];

/** タグ名だけの一覧。 */
export const UNSUPPORTED_SSML_TAG_NAMES: readonly string[] = UNSUPPORTED_SSML_TAGS.map(
  (tag) => tag.name,
);
